import { set, toggle } from '@/utils/vuex'

export default {
  setPaymentList (state, data) {
    state.paymentList = data
  }
}
